module.exports = __webpack_public_path__ + "static/gallery-10@2x-e0325f1f5a9992e97629ab3af97d6f3c.jpg";